import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { FileUploadValidators } from "@iplab/ngx-file-upload";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { AdminService } from "src/app/admin/admin.service";
import { LoaderService } from "src/app/utils/loader.service";
interface DialogData {
  batchId: string | number;
}
@Component({
  selector: "app-update-batch-stage",
  templateUrl: "./update-batch-stage.component.html",
  styleUrls: ["./update-batch-stage.component.scss"],
})
export class UpdateBatchStageComponent implements OnInit {
  stage_file: any;
  fileUploaded: boolean;
  image_url: string | ArrayBuffer;
  batchDetails: any = {
    id: null,
    dispatch_quantity: '',
    dispatch_date: "",
    timeline_flag: "",
    current_stage: {
      name: "Not available"
    },
    created_at: "",
    updated_at: "",
    is_active: true,
    next_stages: [{
      name: "Not available"
    }],
  };

  constructor(
    public dialogref: MatDialogRef<UpdateBatchStageComponent>,
    private dialog: MatDialog,
    private loaderService: LoaderService,
    private adminService: AdminService,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  private filesControl = new FormControl(
    null,
    FileUploadValidators.filesLimit(6)
  );
  public demoForm = new FormGroup({
    files: this.filesControl,
    next_stage: new FormControl()
  });

  ngOnInit(): void {
    this.batchDetails.id = this.data.batchId || 1;
    this.fetchBatch();
    this.attachFiles();
  }

  close() {
    this.dialogref.close();
  }

  attachFiles() {
    const stageFileData = this.demoForm.get("files");
    stageFileData.valueChanges.subscribe((res: any) => {
      this.stage_file = res[0];
      this.fileUploaded = true;
      this.previewUploadedFile(this.stage_file);
    });
  }

  previewUploadedFile(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      this.image_url = event.target.result;
    };
  }

  fetchBatch() {
    this.adminService.fetchVendorOrderItemBatch(this.batchDetails.id).subscribe(
      (res:any) => {
        this.batchDetails = res?.body;
        this.demoForm.patchValue({"next_stage" : this.batchDetails?.next_stages[0]?.id})
        this.loaderService.display(false);
        this.toastr.success("Batch stage fetched successfully", "Success");
      },
      (err) => {
        this.loaderService.display(false);
        for (let i in err.error.errors) {
          this.toastr.error(err.error.errors[i], "Error");
        }
      }
    );
  }

  updateStage() {
    let formData = new FormData();

    formData.append(
      "vendor_order_item_batch[stage_update_file]",
      this.stage_file
    );
    formData.append(
      "current_stage",
      this.demoForm.value["next_stage"]
    );

    this.loaderService.display(true);

    this.adminService
      .updateVendorOrderItemBatch(this.batchDetails.id, formData)
      .subscribe(
        (res) => {
          this.loaderService.display(false);
          this.toastr.success("Batch stage has been updated", "Success");
          this.dialogref.close(res);
        },
        (err) => {
          this.loaderService.display(false);
          for (let i in err.error.errors) {
            this.toastr.error(err.error.errors[i], "Error");
          }
          this.close();
        }
      );
  }

  getStageQuantity():number{
    if(this.batchDetails?.current_stage?.value?.includes('inspection')){
      return this.batchDetails?.ordered_quantity - this.batchDetails?.inventory_quantity;
    }
    else{
      return this.batchDetails?.ordered_quantity;
    }
  }
}
